import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

type UsersTab = { id: string; title: string; link: string };

const TABS: UsersTab[] = [
  { id: 'detail', title: 'Details', link: '/superadmin/users/detail' },
  { id: 'subscription-dunning', title: 'Subscription Dunning', link: '/superadmin/users/subscription-dunning' },
  { id: 'push', title: 'Push Notifications', link: '/superadmin/users/push' },
  { id: 'blacklist', title: 'Blacklisted Users', link: '/superadmin/users/blacklist' },
];

@Component({
  selector: 'app-superadmin-users',
  templateUrl: './superadmin-users.component.html',
  styleUrls: ['./superadmin-users.component.scss'],
})
export class SuperadminUsersComponent implements OnInit {
  tabs: UsersTab[] = TABS;
  activeTab: UsersTab = TABS[0];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.setActiveTab();
    this.router.events.subscribe(() => this.setActiveTab());
  }

  private setActiveTab(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    const url = parsedUrl.toString().split('?')[0];
    this.activeTab = this.tabs.find((tab) => tab.link === url) ?? TABS[0];
  }

  gotoTab(tab: UsersTab): void {
    if (this.activeTab?.id === tab.id) {
      return;
    }
    this.router.navigate([tab.link]).then();
    this.activeTab = tab;
  }
}
